import { Effect, call, put } from "redux-saga/effects";

import { FetchError } from "../utils/api-fetch";
import errorActions from "../error/error.actions";

// import { navigate } from "./history";

type Fn<T> = (...params: any[]) => Promise<T>;

export function* apiCall<T>(fn: Fn<T>, ...args: any[]): Generator<Effect, T, T> {
  try {
    return yield call(fn, ...args);
  } catch (e) {
    if (e instanceof FetchError) {
      console.error(e.message);

      yield put(
        errorActions.setNetworkErrorAction({
          status: e.status,
          statusText: e.message,
          details: e.responseData ? e.responseData : e
        })
      );
    }
    throw e;
  }
}
